import AddChack from "../../components/configuration/chack/AddChack";

const AddChackPage = () => {
    return (
        <AddChack />
    );
};

export default AddChackPage;
